import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
    actions: {
        async getSourcesData(context) {
            const response = await Vue.axios.get(`${URL_API}source`);
            let data = response["data"];
            context.commit("updateSourcesData", data);
        },
        async createSourceData(context, { name, source }) {
            const config = {};
            const body = {
                name: name,
                source: source
            };
            await Vue.axios.post(`${URL_API}source/store`, body, config);
            context.dispatch("getSourcesData");
        },
        async pushSourceData(context, { id, name, source }) {
            const config = {};
            const body = {
                id: id,
                name: name,
                source: source
            };
            await Vue.axios.post(`${URL_API}source/update`, body, config);
            context.dispatch("getSourcesData");
        },
        async destroySourceData(context, id) {
            const config = {};
            const body = {
                id: id
            };
            await Vue.axios.post(`${URL_API}source/destroy`, body, config);
            context.dispatch("getSourcesData");
        }
    },
    mutations: {
        updateSourcesData(state, sourcesData) {
            state.sourcesData = sourcesData;
        }
    },
    state: {
        sourcesData: []
    },
    getters: {
        allSourcesData(state) {
            return state.sourcesData;
        }
    }
};